import { ApplicationState } from '@store/store';

export const paymentStatusSelector = (store: ApplicationState) => store.paymentStatus.paymentStatus;
